export type {
	SquareRecommendData,
	SquareMobileIndexData,
	SquarePcIndexData,
} from "~/utils/page-data/builders/square";
export {
	dedupeSquareRecommendVideos,
	buildSquareMobileIndexData,
	buildSquarePcIndexData,
} from "~/utils/page-data/builders/square";

import type { SquareMobileIndexData, SquarePcIndexData } from "~/utils/page-data/builders/square";
import { fetchPageBff } from "~/utils/page-data/client-fetch";

export async function fetchSquareMobileIndexData(): Promise<SquareMobileIndexData> {
	return fetchPageBff<SquareMobileIndexData>("/seer/api/page/square", {
		platform: "mobile",
	});
}

export async function fetchSquarePcIndexData(): Promise<SquarePcIndexData> {
	return fetchPageBff<SquarePcIndexData>("/seer/api/page/square", {
		platform: "pc",
	});
}
